import countries from "world-countries";

export interface CountryOption {
  label: string;
  value: string; // e.g., "US", "NG"
  flag: string; // optional emoji
}

export const countryOptions: CountryOption[] = countries.map(c => ({
  label: c.name.common,
  value: c.cca2,
  flag: c.flag,
}));
